import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Tooltip,
  styled,
} from '@mui/material'
import {CustomInputLable} from './SelectField'
import {FC, useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {reformatText} from '../utils/InputFormatCurrency'
import Visibility from '@mui/icons-material/Visibility'
import VisibilityOff from '@mui/icons-material/VisibilityOff'
import * as form from '../modules/insurance/healthInsurance/redux/healthInsuranceRedux'
import * as auto from '../modules/insurance/AutoInsurance/redux/autoRedux'
import * as moto from '../modules/insurance/MotoInsurance/redux/motoRedux'
import * as user from '../modules/insurance/healthInsurance/redux/userRedux'
import * as product from '../modules/insurance/InsuranceProducts/redux/productRedux'
import {FormatEmail, FormatIdentity, validateSpecialChar} from '../utils'

type Props = {
  label: string
  id: string
  inputClass?: string
  inputNumberOnly?: boolean
  maxLength?: number
  name: string
  placehoder: string
  inputReadonly?: boolean
  wrapperClass?: string
  inputValue?: string
  tabName?: string
  formName?: string
  required?: boolean
  validateField?: boolean
  formatCurrency?: boolean
  errorText?: string
  phoneNumberOnly?: boolean
  handleInputChange?: (value: string) => void
  handleBlurInput?: (value: string) => void
}

export const CustomInputEndAdornment = styled(OutlinedInput)(({theme}) => ({
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: '#fff',
    fontSize: 12,
    padding: '9px 8px',
  },
  '& .MuiInputLabel-root': {
    color: '#000 !important',
    transform: 'translate(14px, -9px) scale(0.85)',
    backgroundColor: '#fff',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0, 0, 0, 0.1)',
  },
}))

export const InputEndAdornment: FC<Props> = ({
  label,
  id,
  inputNumberOnly,
  inputClass,
  maxLength,
  name,
  inputReadonly,
  wrapperClass,
  inputValue,
  tabName,
  formName,
  required,
  validateField,
  handleInputChange,
  handleBlurInput,
  placehoder,
  formatCurrency,
  errorText,
  phoneNumberOnly,
}) => {
  const [value, setValue] = useState('')
  const [originValue, setOriginValue] = useState('')
  const [show, setShow] = useState(false)
  const dispatch = useDispatch()

  const formatValue = (value: string) => {
    switch (id) {
      case 'identificationNumber':
        setValue(FormatIdentity(value))
        break
      case 'mobile':
      case 'phone':
        setValue(FormatIdentity(value))
        break
      case 'email':
        setValue(FormatEmail(value))
        break
      default:
        break
    }
  }

  const handleChangeData = (event: any) => {
    setShow(true)
    if (!event.nativeEvent.data && !event.nativeEvent?.inputType) {
      handleSaveData(event)
    }
    if (inputNumberOnly) {
      const re = /^[0-9\b,.]+$/
      if (event.target.value === '' || re.test(event.target.value)) {
        setValue(event.target.value)
        if (handleInputChange) handleInputChange(event.target.value)
      }
    } else if (phoneNumberOnly) {
      const re = /^[0-9\b,.\+\s]+$/
      if (event.target.value === '' || re.test(event.target.value)) {
        setValue(event.target.value.trim())
        if (handleInputChange) handleInputChange(event.target.value)
      }
    } else {
      let test = validateSpecialChar(event.target.value)
      if (
        !test &&
        !id.toLocaleLowerCase().includes('address') &&
        !id.toLocaleLowerCase().includes('name')
      )
        event.target.value = event.target.value.replaceAll(',', '')
      setValue(event.target.value)
      if (handleInputChange) handleInputChange(event.target.value)
    }
  }

  const handleSaveData = (event: any) => {
    let value = event.target.value
    if (
      (show || (!event.nativeEvent.data && !event.nativeEvent?.inputType)) &&
      !value.includes('*')
    ) {
      setOriginValue(value.trim())
      formatValue(value.trim())
      if (handleBlurInput) handleBlurInput(value.trim())
      if (formName && formName.toLowerCase().includes('formperson')) {
        let data = {
          key: id,
          value: value.trim(),
          tab: tabName ? tabName : '',
          form: formName ? formName : '',
        }
        dispatch(form.actions.addProductInfo(data))
      } else if (formName && formName.toLowerCase().includes('auto')) {
        let data = {
          key: id,
          value: value.trim(),
          tab: tabName ? tabName : '',
          form: formName ? formName : '',
        }
        dispatch(auto.actions.addAutoInfos(data))
      } else if (formName && formName.toLowerCase().includes('moto')) {
        let data = {
          key: id,
          value: value.trim(),
          tab: tabName ? tabName : '',
          form: formName ? formName : '',
        }
        dispatch(moto.actions.addMotoInfos(data))
      } else if (formName && formName.toLowerCase().includes('product')) {
        let data = {
          key: id,
          value: value.trim(),
          tab: tabName ? tabName : '',
          form: formName ? formName : '',
        }
        dispatch(product.actions.addProductInfos(data))
      } else if (formName === 'user') {
        let data = {
          key: id,
          value: value.trim(),
        }
        dispatch(user.actions.addUserInfo(data))
      }
    }
    setShow(false)
  }

  const handleClickShowPassword = () => setShow((show) => !show)

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  useEffect(() => {
    if (originValue) {
      if (show) setValue(originValue)
      else formatValue(originValue.trim())
    }
  }, [show])

  useEffect(() => {
    if (inputValue) {
      setOriginValue(inputValue)
      if (show) setValue(inputValue)
      else formatValue(inputValue)
    } else {
      setValue('')
      setOriginValue('')
    }
  }, [inputValue])

  return (
    <div className={wrapperClass ? wrapperClass : 'field-wrapper'}>
      <Tooltip
        arrow
        className='tooltip-error-input'
        title={errorText || ''}
        open={validateField && errorText ? true : false}
      >
        <FormControl error={validateField} sx={{width: '100%'}}>
          <CustomInputLable id={id} htmlFor={id} aria-label='test'>
            {label}
            {required && <span className='input-require'> *</span>}
          </CustomInputLable>
          <CustomInputEndAdornment
            label={label}
            key={id}
            id={id}
            type='text'
            name={name}
            className={inputClass}
            placeholder={placehoder}
            value={value}
            onChange={(e) =>
              formatCurrency ? handleChangeData(reformatText(e)) : handleChangeData(e)
            }
            onBlur={(e) => handleSaveData(e)}
            inputProps={{maxLength: maxLength}}
            size='small'
            autoComplete='off'
            fullWidth
            error={validateField}
            endAdornment={
              <InputAdornment position='end'>
                <IconButton
                  aria-label='toggle password visibility'
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge='end'
                >
                  {show ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
      </Tooltip>
    </div>
  )
}

// {validateField && errorText && (
//   <Tooltip id='tooltip-copy-to-clipboard' title="test">
//     <p></p>
//   </Tooltip>
//   // <FormHelperText error id={id}>
//   //   {errorText}
//   // </FormHelperText>
// )}
